export default __webpack_public_path__ + "static/media/signup_background.a464014a.svg";